import {mergeProps as $8mfbS$mergeProps, filterDOMProps as $8mfbS$filterDOMProps, chain as $8mfbS$chain} from "@react-aria/utils";
import {useFocusable as $8mfbS$useFocusable} from "@react-aria/focus";
import {usePress as $8mfbS$usePress} from "@react-aria/interactions";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $4e9d283129286548$exports = {};

$parcel$export($4e9d283129286548$exports, "useButton", () => $4e9d283129286548$export$ea18c227d4417cc3);




function $4e9d283129286548$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = 'button' , isDisabled: isDisabled , onPress: onPress , onPressStart: onPressStart , onPressEnd: onPressEnd , onPressChange: onPressChange , preventFocusOnPress: // @ts-ignore - undocumented
    preventFocusOnPress , allowFocusWhenDisabled: // @ts-ignore - undocumented
    allowFocusWhenDisabled , // @ts-ignore
    onClick: deprecatedOnClick , href: href , target: target , rel: rel , type: type = 'button'  } = props;
    let additionalProps;
    if (elementType === 'button') additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: 'button',
        tabIndex: isDisabled ? undefined : 0,
        href: elementType === 'a' && isDisabled ? undefined : href,
        target: elementType === 'a' ? target : undefined,
        type: elementType === 'input' ? type : undefined,
        disabled: elementType === 'input' ? isDisabled : undefined,
        'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
        rel: elementType === 'a' ? rel : undefined
    };
    let { pressProps: pressProps , isPressed: isPressed  } = $8mfbS$usePress({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps  } = $8mfbS$useFocusable(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = $8mfbS$mergeProps(focusableProps, pressProps, $8mfbS$filterDOMProps(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: $8mfbS$mergeProps(additionalProps, buttonProps, {
            'aria-haspopup': props['aria-haspopup'],
            'aria-expanded': props['aria-expanded'],
            'aria-controls': props['aria-controls'],
            'aria-pressed': props['aria-pressed'],
            onClick: (e)=>{
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn('onClick is deprecated, please use onPress');
                }
            }
        })
    };
}


var $2f16ea8f6283ecbd$exports = {};

$parcel$export($2f16ea8f6283ecbd$exports, "useToggleButton", () => $2f16ea8f6283ecbd$export$51e84d46ca0bc451);



function $2f16ea8f6283ecbd$export$51e84d46ca0bc451(props, state, ref) {
    const { isSelected: isSelected  } = state;
    const { isPressed: isPressed , buttonProps: buttonProps  } = $4e9d283129286548$export$ea18c227d4417cc3({
        ...props,
        onPress: $8mfbS$chain(state.toggle, props.onPress)
    }, ref);
    return {
        isPressed: isPressed,
        buttonProps: $8mfbS$mergeProps(buttonProps, {
            'aria-pressed': isSelected
        })
    };
}




export {$4e9d283129286548$export$ea18c227d4417cc3 as useButton, $2f16ea8f6283ecbd$export$51e84d46ca0bc451 as useToggleButton};
//# sourceMappingURL=module.js.map
